import { Component, OnInit } from '@angular/core';
import { AwsService } from '../../../providers/appsyncservice/aws.service';

@Component({
  selector: 'app-driver-config',
  templateUrl: './driver-config.component.html',
  styleUrls: ['./driver-config.component.css']
})
export class DriverConfigComponent implements OnInit {

  DRIVER_FEEDBACK_STATUS_ITEMS =
    [
      {
        name: 'Enable',
        value: 'TRUE'
      },
      {
        name: 'Disable',
        value: 'FALSE'
      },
    ];

  public driverFeedbackStatus: string;
  private DRIVER_FEEDBACK_STATUS_DB_KEY = "IS_CP_DRIVER_FEEDBACK_ENABLED";
  private id: string;

  constructor(private aws: AwsService) { }

  ngOnInit() {
    console.log("-----> ngOnInit called")
    console.log("-----> driver feedback: ", this.driverFeedbackStatus)
    this.getDriverFeedbackStatus()
  }

  submit() {
    console.log("-----> submit called")
    console.log("-----> driver feedback: ", this.driverFeedbackStatus)
    this.saveDriverFeedbackStatus();
  }

  getDriverFeedbackStatus() {
    this.aws.getMiscData(this.DRIVER_FEEDBACK_STATUS_DB_KEY).then(res => {
      this.driverFeedbackStatus = res[0].data_value;
      this.id = res[0].id;

      console.log("-----> getDriverFeedbackStatus called")
      console.log("-----> driver feedback: ", this.driverFeedbackStatus)
      console.log("-----> id: ", this.id)
    }).catch(err => {
      console.log("getDriverFeedbackStatus-err", err)
    })
  }

  saveDriverFeedbackStatus() {
    console.log("-----> saveDriverFeedbackStatus called")
    //var id: string;

    // get id
    /*this.aws.getMiscData(this.DRIVER_FEEDBACK_STATUS_DB_KEY).then(res => {
      id = "" + res[0].id;
      console.log("-----> driver feedback id: ", id)
    }).catch(err => {
      console.log("getDriverFeedbackStatus-err", err)
    })*/

    //update value
    this.aws.updateMiscData(this.id, this.DRIVER_FEEDBACK_STATUS_DB_KEY, this.driverFeedbackStatus).then(res => {
      this.driverFeedbackStatus = res[0].data_value;

      console.log("-----> DriverFeedbackStatus updated")
      console.log("-----> miscData: ")
      console.log(res[0])
    }).catch(err => {
      console.log("saveDriverFeedbackStatus-err", err)
    })

  }

}
